import React, { useState } from 'react';
import useStyles from './styles';
import {
  MULTIPLE_IMAGE_QUESTION,
  IMAGE,
  VIDEO,
  AUDIO,
  AUDIO_BACKGROUND,
} from '../../../../utils/const/pageTypes';

const MultimediaAnswer = ({ editableAnswer, setEditableAnswer, type }) => {
  const classes = useStyles();
  const [isDragOver, setIsDragOver] = useState(false);

  const getFileLimit = () => {
    switch (type) {
      case IMAGE:
        return 1;
      case MULTIPLE_IMAGE_QUESTION:
        return 60;
      case VIDEO:
        return 1;
      case AUDIO:
      case AUDIO_BACKGROUND:
        return 1;
      default:
        return 1;
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleFiles = (files) => {
    const currentFiles = editableAnswer || [];
    const fileLimit = getFileLimit();
    const availableSlots = fileLimit - currentFiles.length;

    if (availableSlots <= 0) {
      return;
    }

    const filesToAdd = Array.from(files).slice(0, availableSlots);
    const newFiles = filesToAdd.map((file) => {
      if (file.type.startsWith('image/')) {
        return {
          name: file.name,
          size: file.size,
          type: file.type,
          url: URL.createObjectURL(file),
          file,
          isExisting: false,
        };
      }
      return {
        name: file.name,
        size: file.size,
        type: file.type,
        file,
        isExisting: false,
      };
    });

    setEditableAnswer([...currentFiles, ...newFiles]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e.dataTransfer.files);
    handleFiles(files);
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    handleFiles(files);
  };

  const removeFile = (indexToRemove) => {
    const updatedFiles = editableAnswer.filter((_, index) => index !== indexToRemove);
    setEditableAnswer(updatedFiles);
  };

  const showPreview = (file) => {
    const name = file.name.toLowerCase();

    return (
      name.endsWith('.jpg')
      || name.endsWith('.jpeg')
      || name.endsWith('.png')
      || name.endsWith('.gif')
      || name.endsWith('.webp')
      || (file.type && file.type.startsWith('image/'))
    );
  };

  return (
    <div className={classes.content}>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={`${classes.dropzone} ${isDragOver ? 'dragOver' : ''}`}
      >
        <input
          type="file"
          multiple
          accept="image/*,video/*,audio/*"
          onChange={handleFileSelect}
          className={classes.fileInput}
          id="file-input"
        />
        <label htmlFor="file-input" style={{ cursor: 'pointer' }}>
          <p>Arrastra archivos aquí o haz clic para seleccionar</p>
        </label>
      </div>

      <div className={classes.fileList}>
        <h4>Archivos seleccionados: {editableAnswer?.length || 0}/{getFileLimit()}</h4>
        {editableAnswer?.length > 0 && (
          <ul>
            {editableAnswer.map((file, index) => (
              <li key={index} className={classes.fileItem}>
                <button
                  onClick={() => removeFile(index)}
                  className={classes.removeButton}
                >
                  ×
                </button>
                <div className={classes.fileContainer}>
                  {showPreview(file) && (
                    <img
                      src={file.url}
                      alt={file.name}
                      className={classes.imagePreview}
                    />
                  )}
                  <span>
                    {file.name}
                    {file.size && ` (${(file.size / 1024).toFixed(1)} KB)`}
                    {file.isExisting && ' (existente)'}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MultimediaAnswer;
